module.exports = __webpack_public_path__ + "media/images/bnr-friend-1c9974caad4fb10f94ecaab78a169e84.png";